import React from 'react';
import { Check, Robot } from '@phosphor-icons/react';
import { useI18n } from '../../contexts/I18nContext';
import { useRelativeTime } from '../../lib/time';
import { isAutoClosed, reasonText } from '../../lib/alertText';

// Who closed (or is handling) an alert: a person, or the system with no actor.
export function AlertClosure({ alert: a, testid }) {
  const { t } = useI18n();
  const rel = useRelativeTime();
  if (a.status === 'resolved' && isAutoClosed(a)) {
    const reason = reasonText(a.resolution_reason, t);
    return (
      <div className="text-xs text-ink-soft mt-3 flex items-start gap-1.5" data-testid={testid}>
        <Robot size={14} className="text-ink-muted mt-0.5 shrink-0" weight="duotone" />
        <span>
          <span className="text-ink">{reason ? t('al_auto_closed_reason', { reason }) : t('al_auto_closed')}</span>
          <span className="text-ink-muted"> · {rel(a.resolved_at)} · {t('al_never_seen')}</span>
        </span>
      </div>
    );
  }
  if (a.status === 'resolved' && (a.resolved_by_name || a.resolved_by)) {
    return (
      <div className="text-xs text-sage-600 mt-3 inline-flex items-center gap-1.5" data-testid={testid}>
        <Check size={14} weight="bold" />
        {a.resolved_by_name ? t('al_resolved_by', { name: a.resolved_by_name }) : t('status_resolved')} · {rel(a.resolved_at)}
      </div>
    );
  }
  if (a.acknowledged && a.status !== 'resolved') {
    return (
      <div className="text-xs text-sage-600 mt-3 inline-flex items-center gap-1.5" data-testid={testid}>
        <Check size={14} weight="bold" />
        {t('acknowledged_by')}: {a.acknowledged_by} · {rel(a.acknowledged_at)}
      </div>
    );
  }
  return null;
}
